/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export type CostChannel = 'DEFAULT_COST_CHANNEL' | 'DELIVERY_COST_CHANNEL' | 'PICKUP_COST_CHANNEL';

export type BagUpsellItemsQueryVariables = Exact<{
  restaurantId: string;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type BagUpsellItemsQuery = {
  readonly categoryUpsells: ReadonlyArray<{
    readonly __typename: 'UpsellCategory';
    readonly id: string;
    readonly name: string;
    readonly categoryRanking: number;
    readonly products: ReadonlyArray<{
      readonly __typename: 'UpsellCategoryProduct';
      readonly id: string;
      readonly name: string;
      readonly cost: number;
      readonly channelCost: number;
      readonly imageUrl: string;
      readonly outOfStock: boolean;
      readonly menuId: number;
    }>;
  }>;
};

export const BagUpsellItemsDocument = gql`
  query BagUpsellItems($restaurantId: String!, $costChannel: CostChannel) {
    categoryUpsells(restaurantId: $restaurantId) {
      id
      __typename
      name
      categoryRanking
      products {
        id
        __typename
        name
        cost
        channelCost(costChannel: $costChannel)
        imageUrl
        outOfStock
        menuId
      }
    }
  }
`;

export function useBagUpsellItemsQuery(
  options: Omit<Urql.UseQueryArgs<BagUpsellItemsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BagUpsellItemsQuery, BagUpsellItemsQueryVariables>({
    query: BagUpsellItemsDocument,
    ...options,
  });
}
